import React from 'react';
import * as Sentry from '@sentry/react';
import { colors as theme } from '../theme';

const colors = {
  primary: theme.gold,
  bg: theme.bg,
  bgCard: theme.surface1,
  border: theme.borderStrong,
  text: theme.text,
  textMuted: theme.textMuted,
  danger: theme.danger,
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true, errorId: Date.now().toString(36) };
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error, { contexts: { react: { componentStack: info.componentStack } } });
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught:', error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, errorId: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: colors.bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          fontFamily: "'Inter', sans-serif",
        }}>
          <div style={{
            maxWidth: '480px',
            width: '100%',
            background: colors.bgCard,
            padding: '40px',
            borderRadius: '20px',
            border: `1px solid ${colors.border}`,
            textAlign: 'center',
          }}>
            <div style={{ fontSize: '56px', marginBottom: '20px' }}>⚠️</div>
            <h1 style={{
              fontSize: '20px',
              fontWeight: 700,
              color: colors.text,
              marginBottom: '12px',
            }}>
              Something went wrong
            </h1>
            <p style={{
              fontSize: '14px',
              color: colors.textMuted,
              marginBottom: '8px',
              lineHeight: 1.6,
            }}>
              An unexpected error occurred. Your workout data is safe — this is a display issue only.
            </p>
            <p style={{
              fontSize: '12px',
              color: colors.textMuted,
              marginBottom: '32px',
            }}>
              Error ID: {this.state.errorId}
            </p>
            <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>
              <button
                onClick={this.handleReload}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: `linear-gradient(135deg, ${colors.primary}, ${theme.goldPressed})`,
                  border: 'none',
                  borderRadius: '14px',
                  color: theme.bg,
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Reload App
              </button>
              <button
                onClick={this.handleReset}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: colors.bgCard,
                  border: `1px solid ${colors.border}`,
                  borderRadius: '14px',
                  color: colors.text,
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Try to Recover
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
